"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const immer_1 = tslib_1.__importDefault(require("immer"));
const getState_1 = require("../../helpers/getState");
const command_1 = require("../../type/command");
const zeroStates_1 = require("../../zeroStates");
const applyRegisterILTSessionCommand_1 = require("../applyRegisterILTSessionCommand");
const applyRegisterILTSessionsCommand_1 = require("../applyRegisterILTSessionsCommand");
const updateEventAttributeFields_1 = require("../helpers/updateEventAttributeFields");
const addAssignEvent_1 = tslib_1.__importDefault(require("./addAssignEvent"));
const updateEnrolments_1 = tslib_1.__importDefault(require("./updateEnrolments"));
function getSessionIdsFromUnitSettings(currentUnitSetting) {
    let sessionIds = [];
    if (currentUnitSetting) {
        if (currentUnitSetting.sessionId) {
            sessionIds = [currentUnitSetting.sessionId];
        }
        else if (currentUnitSetting.sessionIds) {
            sessionIds = currentUnitSetting.sessionIds;
        }
    }
    return sessionIds;
}
function registerSessionsOfILT(command, user, content, states) {
    const { id, creatorId, timeStamp, unitSettings } = command;
    const currentUnitSetting = (unitSettings || []).find(unitSetting => unitSetting.unitId === content._id);
    // extract sessionIds from command's currentSettings
    const sessionIds = getSessionIdsFromUnitSettings(currentUnitSetting);
    if (sessionIds.length > 0) {
        let registerSessionPayload;
        if (!content.registrationType || content.registrationType === 'single') {
            // if ILT is of single register type so call apply single register command
            const registerSessionCommand = {
                id,
                type: command_1.CommandType.REGISTER_SESSION,
                creatorId,
                contentId: content._id,
                sessionId: sessionIds[0],
                learnerType: currentUnitSetting.learnerType,
                timeStamp
            };
            registerSessionPayload = applyRegisterILTSessionCommand_1.applyRegisterILTSessionCommand(registerSessionCommand, user, states);
        }
        else {
            // if ILT is of multiple register type so call apply multiple register command
            const registerSessionsCommand = {
                id,
                type: command_1.CommandType.REGISTER_SESSIONS,
                creatorId,
                contentId: content._id,
                sessionIds,
                learnerType: currentUnitSetting.learnerType,
                timeStamp
            };
            registerSessionPayload = applyRegisterILTSessionsCommand_1.applyRegisterILTSessionsCommand(registerSessionsCommand, user, states);
        }
        return registerSessionPayload;
    }
    return undefined;
}
function applyAssignILT(command, user, content, states, enrolments, stateInteractions) {
    let updatedEnrolments = enrolments;
    const updatedStateInteractions = stateInteractions;
    let newEvents = [];
    const updatedStates = immer_1.default(states, draftStates => {
        let state = getState_1.getStateByContentIdUserId(draftStates, content._id, user.userId);
        if (!state) {
            [state] = zeroStates_1.zeroStates(content, user);
            draftStates.push(state);
        }
        const registerSessionPayload = registerSessionsOfILT(command, user, content, draftStates);
        updatedEnrolments = updateEnrolments_1.default(enrolments, command, content, user);
        const diffEnrolments = updatedEnrolments.filter((enrolment, index) => {
            if (enrolment !== enrolments[index]) {
                return enrolment;
            }
        });
        if (diffEnrolments.length > 0) {
            addAssignEvent_1.default(command, updatedEnrolments, user, content, newEvents);
        }
        if (registerSessionPayload) {
            newEvents = newEvents.concat(registerSessionPayload.events);
            if ('toSendMail' in command && command.toSendMail === false) {
                updateEventAttributeFields_1.updateEventAttributeFields(newEvents, { toSendMail: false });
            }
            draftStates = registerSessionPayload.states;
        }
    });
    return {
        events: newEvents,
        states: updatedStates,
        stateInteractions: updatedStateInteractions,
        enrolments: updatedEnrolments
    };
}
exports.applyAssignILT = applyAssignILT;
//# sourceMappingURL=applyAssignILT.js.map